import { ButtonLink } from "~/shared/components/ds/ButtonLink";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { ASSIGNMENT_PATHS } from "~/team/constants/paths.constants";

export function AssignmentNotFound({ children }: { children: React.ReactNode }) {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Assignment unavailable</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            We couldn&apos;t find this assignment, or the link may be broken. View your assignment list to see
            what&apos;s available, or try reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>{children}</ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}

export function TeamAssignmentNotFound() {
  return (
    <AssignmentNotFound>
      <ButtonLink variant="default" to={ASSIGNMENT_PATHS.root}>
        View Assignments
      </ButtonLink>
    </AssignmentNotFound>
  );
}
